<template>
    <el-dialog center title='提示' :visible.sync="public_model.public_model_show" class="pulbicConfirm" width="400px" :show-close='false'>
        <div class="content" v-html='public_model.public_model_text'></div>
        <el-row class="footer-but">
            <el-col :span="12">
                <div class="grid-content bg-purple-dark cancel" @click="public_model_hide">取消</div>
            </el-col>
            <el-col :span="12">
                <div class="grid-content bg-purple-dark sure" @click="public_model_sure">确定</div>
            </el-col>
        </el-row>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
export default {
    computed:{
        ...mapState({
            public_model:(state) => state.user.public_model
        })
    },
    methods:{
        //公共关闭弹窗
        public_model_hide(){
            this.$store.commit('hide_public_model');
        },
        //公共确定
        public_model_sure(){
            console.log(this.public_model)
            console.log(this.public_model.public_model_text == "更换人脸头像会导致无法继续学习，等待审核通过后方能学习")
            if( this.public_model.public_model_text == "更换人脸头像会导致无法继续学习，等待审核通过后方能学习" ){
                this.$emit('sureOpen');
            }else if(this.public_model.public_model_param.checkHours){
                this.$emit('signUp');
                
            }else{
                this.$emit('sure');
            }


            this.$store.dispatch('public_model_sure');
        },
    }
}
</script>
<style lang="stylus">
.pulbicConfirm .el-dialog--center .el-dialog__body
    text-align center!important
    padding 0!important
.pulbicConfirm
    .el-dialog
        border-radius 8px
    .el-dialog__title{
      color: red
    }
    .content
        padding 20px

    .footer-but
        border-top 1px solid #EEEEEE
        .cancel,.sure
            padding 11px 0 14px
            font-size 16px
            cursor pointer
        .cancel
            border-right 1px solid #EEEEEE
            color #333333
        .sure
            color $textColorBlue
</style>



// WEBPACK FOOTER //
// src/components/common/confirm.vue